import { createContext, useContext } from "react";

/**
 * Type representing the projectSelector module
 * This provides environment-specific configuration and utilities
 */
export type ProjectSelector = typeof import("@rflocal/shared/utils/projectSelector.js");

/**
 * Context for accessing projectSelector throughout the Rapid app
 * This avoids using window globals and provides a clean React-based API
 */
export const ProjectSelectorContext = createContext<ProjectSelector | null>(null);

/**
 * Hook to access projectSelector in any component
 * @throws Error if used outside of ProjectSelectorProvider
 */
export function useProjectSelector(): ProjectSelector {
    const context = useContext(ProjectSelectorContext);
    if (!context) {
        throw new Error("useProjectSelector must be used within a ProjectSelectorProvider");
    }
    return context;
}
